<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    
    <!-- 修改 -->
    <div class="content reviseBox" v-if="reviseType">
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>开通机构和账号/添加机构和账号</p>
        </div>
        <div class="organiza-cont">
          <div class="detail">
            <p class="detail-title">修改密码</p>
            <div class="info">
              <div class="info-item">
                <p class="info-title">机构名称:</p>
                <input type="text" >
              </div>
              <div class="info-item">
                <p class="info-title">初始密码:</p>
                <input type="text" >
                <p class="info-msg">密码长度：8位~16位，必须包含字母、数字、符号至少2种以上元素</p>
              </div>
              <div class="info-item">
                <p class="info-title">用户名:</p>
                <input type="text" >
                <p class="info-msg">用户名为4位~20位字母</p>
              </div>
              <div class="info-item">
                <p class="info-title">手机号:</p>
                <input type="text" >
              </div>
            </div>
          </div>
          <button class="btn btn-sub">确认添加</button>
        </div>
      </div>
    </div>

    <!-- 添加提示框 -->
    <div class="msgBox tipsBox addBox" v-if="addType">
      <div class="contv">
        <p class="title">添加帐号</p>
        <form>
          <div class="write-txt">
            <p>机构名称：</p>
            <input type="text" v-model="addObj.title">
          </div>
          <div class="write-txt">
            <p>初始密码：</p>
            <input type="text" v-model="addObj.password">
          </div>
          <div class="write-txt">
            <p>用户名：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>手机号：</p>
            <input type="text" v-model="addObj.mobile">
          </div>
          <div class="write-txt">
            <p>类型：</p>
            <select v-model="addObj.type">
              <option value="1">题库</option>
              <option value="2">模拟卷</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">添加</button>
          <button class="btn btn-close" @click="addType=false;">取消</button>
        </div>
      </div>
    </div>

    <!-- 修改提示框 -->
    <div class="msgBox tipsBox addBox " v-if="replaceType">
      <div class="contv">
        <p class="title">修改操作</p>
        <form>
          <div class="write-txt">
            <p>机构名称：</p>
            <input type="text" v-model="replaceObj.title" disabled>
          </div>
          <div class="write-txt">
            <p>初始密码：</p>
            <input type="text" v-model="replaceObj.password">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="replaceSub">确认</button>
          <button class="btn btn-close" @click="replaceHide">取消</button>
        </div>
      </div>
    </div>

    <!-- 删除提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认删除该机构号管理员账号吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeType=false">删除</button>
          <button class="btn btn-close" @click="removeType=false">取消</button>
        </div>
      </div>
    </div>

    <!-- 开通提示框 -->
    <div class="msgBox removeBox" v-if="openType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">一旦提交无法修改，确认开通吗？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="">确认开通</button>
          <button class="btn btn-close" @click="">取消</button>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="content" >
      <myHeader></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>开通机构和账号</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加账号</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#457AFF;" @click="replaceShow(item)">修改</p>
              <p style="color:#FF5156;" @click="lookAdmin(item)">管理员</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { addOrg,getOrgDetail,getOrgList,updatePassword } from "@/assets/js/api";
export default {
  name: "topic-config",
  data() {
    return {
      navId:'5',
      childrenID:'5-4',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'机构名称'},
        {id:3,title:'开通时间'},
      ],
      dataList:[],
      addType:false,
      removeType:false,
      reviseType:false,
      openType:false,
      replaceType:false,
      token:'',
      obj:{
        page:1,
        rows:10,
      },
      addObj:{
        title:'',
        password:'',
        mobile:'',
        name:'',
        type:1
      },
      replaceObj:{},
      totalPage:0
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = this.$refs.navBox.userData.token;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    lookAdmin(e){
      this.$router.push('/organ?organID='+e.id)
    },

    getList(){
      var that = this;
      var data = this.obj;
      getOrgList(data,this.token).then((res) => {
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      });
    },

    // 添加机构
    addSub(){
      var that = this;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i;
      if(that.addObj.title == ''){
        this.$message('请填写机构名称');
        return false;
      } else if(this.addObj.password == ''){
        this.$message('请填写正确的密码');
        return false;
      } else if(this.addObj.mobile === '' || !regex.test(this.addObj.mobile)){
        that.$message('请输入正确的手机号码！');
        return false;
      } else if(this.addObj.name == ''){
        this.$message('请填写正确的姓名');
        return false;
      };
      addOrg(this.addObj,this.token).then((res) => {
        var data = res.data;
        if(data.code == 200){
          that.$message('添加成功');
          that.addType = false;
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.addObj={
        title:'',
        password:'',
        mobile:'',
        name:'',
        type:1
      };
      this.addType = true;
    },

    replaceShow(e){
      var that = this;
      var data = {
        id:e.id
      };
      getOrgDetail(data,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.replaceType = true;
          that.replaceObj = data.data;
        } else {
          that.$message(data.msg);
        }
      })
    },

    replaceSub(){
      var that = this;
      var password = this.replaceObj.password;
      if(password == ''){
        that.$message('请填写正确的密码');
        return false;
      };
      var data = {
        id:this.replaceObj.id,
        password:password
      };
      updatePassword(data,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('修改成功！');
          that.replaceHide();
          that.obj = {
            page:1,
            rows:10,
          };
          that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    replaceHide(){
      var that = this;
      that.replaceObj = {};
      that.replaceType = false;
    },


  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 20%; 
}

.organiza-txt{
  height: calc(100% - 120px);
}

.organiza-cont .detail-title{
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #3D3D3D;
}

.organiza-cont .info-item {
  margin-bottom: 30px;
}

.organiza-cont .info-item p{
  font-size: 20px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  height: 36px;
}

.organiza-cont .info-item p.info-msg{
  font-size: 14px;
  margin-left: 24px;
}

.organiza-cont .info-item p.info-title{
  width: 100px;
}

.organiza-cont .info-item input{
  font-size: 20px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
  width: 300px;
  line-height: 36px;
  height: 36px;
  border: solid 1px #BFC3CD;
  border-radius: 6px;
  padding: 5px 10px;
}

.organiza-cont .info-item button{
  color: #457AFF;
  font-size: 20px;
  display: inline-block;
  vertical-align: top;
  line-height: 36px;
  height: 36px;
  margin-left: 18px;
}

.organiza-cont .btn-sub{
  width: 200px;
  height: 60px;
  left: 60px;
  border-radius: 30px;
  color: #fff;
  text-align: center;
  font-size: 22px;
  background-color: #457AFF;
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/admin/open.vue